import { Dialog, DialogTitle, DialogContent, Typography, List, ListItem, ListItemText, ListItemIcon, Divider, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

const AccountVsProfile = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle sx={{ m: 0, p: 2 }}>
      Account vs. Public Profile
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
    <DialogContent dividers>
      <Typography variant="body1" paragraph>
        Whats the difference between your <i>Account</i> and a <i>Public Profile</i>? Here's what each provides:
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Typography variant="h6" gutterBottom>Account</Typography>
      <Typography variant="body2" gutterBottom>
        You need an account to save events (RSVP), or to add events to the calendar.
      </Typography>
      <Typography variant="body2" gutterBottom>
        By default, your account is 100% private. Email is never shared or used for marketing purposes.
      </Typography>
      <List>
        <ListItem>
          <ListItemIcon>
            <CheckIcon />
          </ListItemIcon>
          <ListItemText primary="RSVP to events" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckIcon />
          </ListItemIcon>
          <ListItemText primary="Star events for easy recollection." />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckIcon />
          </ListItemIcon>
          <ListItemText primary="Integrate your starred events with your calendar app." />
        </ListItem>
      </List>
      <Divider sx={{ my: 2 }} />
      <Typography variant="h6" gutterBottom>Public Profile</Typography>
      <Typography variant="body2" gutterBottom>
        Want to share more with the community? User your account to create a public profile!
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="Everything from above plus:" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckIcon />
          </ListItemIcon>
          <ListItemText primary="Share playlists, instagram posts and your public profile in the Community tab" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckIcon />
          </ListItemIcon>
          <ListItemText primary="Be recognized for your contributions (e.g., playlists, comments)" />
        </ListItem>
      </List>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        You can delete a public profile at any time.
      </Typography>
    </DialogContent>
  </Dialog>
);

export default AccountVsProfile;
